import { QuestionnaireWizard } from '../company/Questionnaire.tsx';

// The driver questionnaire is the company wizard pointed at the driver
// endpoints. The wizard reads its API prefix and query keys from context
// so the inner question/file/adoption components seamlessly target the
// driver path.
export function DriverQuestionnaire() {
  return (
    <QuestionnaireWizard
      apiPrefix="/api/driver/me"
      meQueryKey={['driver-me']}
      submitButtonLabel="Submit driver questionnaire"
    />
  );
}
